var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card-title',[_vm._v("กราฟแสดง Trend จำนวนเคสค้างสะสมย้อนหลัง")]),_c('SimpleColumnChart',{attrs:{"isMock":false,"data":_vm.items,"categoryField":"title","valueField":"count","valueText":"จำนวนเคส"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }